// Capacitor
import { Capacitor } from '@capacitor/core';

/**
 * 一般的に利用出来るツールを定義する
 */

//=================================================================
// 通信用スクリプト
//=================================================================

/**
 * URIのデコードを行う
 * javascriptのdecodeURIComponentではjava.URLEncoderが空白を+にエンコードしたものを
 * 戻せないので、decodeURIComponentを呼び出す前に+を空白(16進)に変換する。
 * 以下がjava.URLEncoderの仕様
 * ・英数字文字の「a」から「z」、「A」から「Z」、および「0」から「9」は元のまま残す
 * ・特殊文字の「.」、「-」、「*」、および「_」は元のまま残す
 * ・空白文字「 」をプラス記号「+」に変換する <- javascriptのdecodeURIComponentではこのデコードが出来ない。
 * ・ほかのすべての文字は安全でなく、最初に何らかのエンコーディング方式を使用して1つ以上のバイトに変換される。
 *   次に、各バイトが 3 文字から成る文字列「%xy」で表現される。ここで、xy はそのバイトを2桁の16進数として
 *   表現したものである。使用が推奨されるエンコーディング方式はUTF-8である。
 *   ただし、互換性上の理由によりエンコーディングが指定されていない場合には、プラットフォームのデフォルトの
 *   エンコーディングが使用される。
 */
export function decodeURI(str: string)
{
    if ( str == null ) return(null);
	// decodeURIComponentを呼び出す前に+を空白(16進)に変換する
	return(decodeURIComponent(str.replace(/\+/g, "%20")));
}

/**
 * サニタイイング用関数
 *
 * @param String サニタイジング対象文字列
 * @returns String サニタイジング済み文字列
*/
export function sanitize(str: string)
{
    // 2023/1/10 方針
    // vue-sanitizeに置き換える
    // 暫定的に受け取った文字列をそのまま返す
    return(str);
	// if (str == null || str == "" ) return("");
    //  return str.replace(/[&<>"']/g, function(match)
    //  {
    //       return {
    //            '&' : '&amp;',
    //            '<' : '&lt;',
    //            '>' : '&gt;',
    //            '"' : '&quot;',
    //            "'" : '&#039;'
    //       }[match];
    //  });
}

/**
 * 非サニタイジング関数
 *
 * @param String 非サニタイジング対象文字列
 * @returns String 非サニタイジング済み文字列
*/
export function unSanitize(str: string)
{
	if (str == null || str == "" ) return("");
	return str.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, '\'').replace(/&amp;/g, '&');
}

//=================================================================
// チェック用スクリプト
//=================================================================

// 身長
export function isValidBodyHeight(height: number)
{
	if ( height < 0 || height > 250 )
	{
		return(false);
	}
	return(true);
}

// 体重
export function isValidBodyWeight(weight: number)
{
	if ( weight < 0 || weight > 400 )
	{
		return(false);
	}
	return(true);
}

/**
 * 使用中の端末がAndoridか判断する
 * @return true - android, flase - それ以外
 */

export function isAndroid()
{
    return(Capacitor.getPlatform() == "android");
}

/**
 * 使用中の端末がiOSか判断する
 * @return true - ios, flase - それ以外
 */
export function isIOS()
{
    return(Capacitor.getPlatform() == "ios");
}

//=================================================================
// 日付用スクリプト
//=================================================================

/**
 * YYYYMMDDをフォーマット済み年月日に変換する
 *
 * @param country 2バイトのISOカントリーコード
 * @param yyyymmdd YYYYMMDD形式の年月日
 * @return ロケールがJPの時はYYYY/MM/DD、それ以外はMM/DD/YYYYを返す
 */
export function convDateTimeFm2(country: string, yyyymmdd: string)
{
    if ( yyyymmdd == null || yyyymmdd.length != 8 )
    {
            return(null);
    }
    let str = "";
    if ( country == "JP" )
    {
            // YYYY/MM/DD
            str += yyyymmdd.substring(0,4)+"/"
                + yyyymmdd.substring(4,6)+"/"
                + yyyymmdd.substring(6,8);
    }
    else
    {
            // MM/DD/YYYY
            str += yyyymmdd.substring(4,6)+"/"
                + yyyymmdd.substring(6,8)+"/"
                + yyyymmdd.substring(0,4);
    }
    return(str);
}

/**
 * YYYYMMDDをフォーマット済み月日に変換する
 *
 * @param country 2バイトのISOカントリーコード
 * @param yyyymmdd YYYYMMDD形式の年月日
 * @return 現時点ではロケールに関係なくMM/DDを返す
 */
export function convDateTimeFm3(country: string, yyyymmdd: string)
{
    if ( yyyymmdd == null || yyyymmdd.length != 8 )
    {
            return(null);
    }
    return(yyyymmdd.substring(4,6)+"/"+yyyymmdd.substring(6,8));
}

/**
 * YYYY/MM/DDから/を外してYYYYMMDDに変換する
 *
 * @param yyyymmdd YYYY/MM/DD形式の年月日
 * @return YYYYMMDDを返す
 */
export function convDateTimeFm5(yyyymmdd: string)
{
	if ( yyyymmdd == null ) return(null);
	return(yyyymmdd.replace(/\//g,""));
}

/**
 * YYYY-MM-DDから-を外してYYYYMMDDに変換する
 *
 * @param yyyymmdd YYYY-MM-DD形式の年月日
 * @return YYYYMMDDを返す
 */
export function convDateTimeFm6(yyyymmdd: string)
{
	if ( yyyymmdd == null ) return(null);
	return(yyyymmdd.replace(/-/g,""));
}

/**
 * YYYYMMをフォーマット済み年月に変換する
 *
 * @param yyyymm YYYYMM形式の年月
 * @return YYYY/MMを返す
 */
export function convDateTimeFm7(yyyymm: string)
{
    if ( yyyymm == null || yyyymm.length != 6 )
    {
            return(null);
    }
    // YYYY/MM
    return(
        yyyymm.substring(0,4)+"/"
        + yyyymm.substring(4,6));
}


/**
 * hhmmssをhh:mm:ssに変換する
 *
 * @param hhmmss hhmmss形式の時刻
 * @return hh:mm:ssを返す
 */
export function convTimeFm1(hhmmss: string)
{
	if ( hhmmss == null ) return(null);
    return(hhmmss.substring(0,2)+":"+hhmmss.substring(2,4)+":"+hhmmss.substring(4,6));
}

/**
 * hhmmssをhh:mmに変換する
 *
 * @param hhmmss hhmmss形式の時刻
 * @return hh:mmを返す
 */
export function convTimeFm2(hhmmss: string)
{
	if ( hhmmss == null ) return(null);
    return(hhmmss.substring(0,2)+":"+hhmmss.substring(2,4));
}

/**
 * 開始時刻と終了時刻を編集して返す
 *
 * @param strtHhmm HH:MM形式の開始時刻
 * @param endHhmm  HH:MM形式の終了時刻
 * @returns 開始時刻-終了時刻(HH:MM-HH:MM)に編集した内容を返す。時刻が無い場合は空が返る
 */
export function editTime(strtHhmm: string, endHhmm: string)
{
	let editedTime = '';
	if ( strtHhmm != null )
	{
		/* 開始時刻 */
		if ( strtHhmm.indexOf('0') == 0 )
		{
			/* 先頭の0を削除する */
			editedTime += strtHhmm.substring(1);

		}
		else
		{
			editedTime += strtHhmm;
		}
		/* 終了時刻 */
		if ( endHhmm != null && endHhmm > strtHhmm )
		{
			if ( endHhmm.indexOf('0') == 0 )
			{
				/* 先頭の0を削除する */
				editedTime += '-' + endHhmm.substring(1);
			}
			else
			{
				editedTime += '-' + endHhmm;
			}
		}
	}
	return editedTime;
}

/**
 * 開始時刻と終了時刻を編集して返す
 * 終了時刻がオール0の場合は、終了時刻を表示しない
 *
 * @param strtHhmmss HHMMSS形式の開始時刻
 * @param endHhmmss  HHMMSS形式の終了時刻
 * @returns 開始時刻-終了時刻(HH:MM-HH:MM)に編集した内容を返す。時刻が無い場合は空が返る
 */
export function editTime2(strtHhmmss: string, endHhmmss: string)
{
	let editedTime = '';
	if ( strtHhmmss != null )
	{
		/* 開始時刻 */
		if ( strtHhmmss.indexOf('0') == 0 )
		{
			/* 先頭の0を削除する */
			editedTime += convTimeFm2(strtHhmmss)!.substring(1)

		}
		else
		{
			editedTime += convTimeFm2(strtHhmmss);
		}
		/* 終了時刻 */
		if ( endHhmmss != null && endHhmmss > strtHhmmss )
		{
            // 終了時刻がオール0の場合は、終了時刻を表示しない
            if ( endHhmmss == "000000" ) { return editedTime; }
            if ( endHhmmss.indexOf('0') == 0 )
			{
				/* 先頭の0を削除する */
				editedTime += '-' +  convTimeFm2(endHhmmss)!.substring(1)
			}
			else
			{
				editedTime += '-' + convTimeFm2(endHhmmss);
			}
		}
	}
	return editedTime;
}

/**
 * 渡された時刻をJSTに変換して返す
 * 
 * @param 時刻
 */
export function GMT2JST(datetime: Date)
{
    // 受け取ったdatetaimeからDateをnewするとJSTになるのでそのまま返す。
    const d = new Date(datetime);
    return d;
}

/**
 * タイムゾーンがGMTの場合、渡された時刻をJSTからGMTに変換する
 * タイムゾーンがGMT以外の場合はそのまま返す
 * 
 * @param 時刻
 */
export function JST2GMT(datetime: Date)
{
    const offset = new Date().getTimezoneOffset();
    if ( offset == 0 )
    {
        // タイムゾーンがGMTなので-540する
        datetime.setMinutes(datetime.getMinutes() -540 );
    }
    return datetime;
}

/**
 * タイムスタンプ型を文字列yyyy年m月d日 HH:MM:SSに返還
 *
 * @param タイムスタンプ
 * @returns 年月日時分秒の文字列を返す yyyy年m月d日 HH:MM:SS
 */
export function convTimeStampFm(timeStamp: any)
{
    const recDate = new Date(timeStamp);
    const year = recDate.getFullYear();
    const month = recDate.getMonth()+1;
    const day = recDate.getDate();
    const hours = recDate.getHours();
    const minutes = recDate.getMinutes().toString().padStart( 2, '0');
    const seconds = recDate.getSeconds().toString().padStart( 2, '0');

    const dateString = year + "年" + month + "月" + day + "日";
    const timeString = hours + ":" + minutes + ":" + seconds;
    return (dateString + " " + timeString);
}

/**
 * タイムスタンプ型を文字列yyyy年m月d日 HH:MM:SSに返還
 *
 * @param タイムスタンプ
 * @returns 年月日時分秒の文字列を返す yyyy年m月d日 HH:MM:SS
 */
export function convTimeStampFm2(timeStamp: any)
{
    const recDate = new Date(timeStamp);
    const year = recDate.getFullYear();
    const month = recDate.getMonth()+1;
    const day = recDate.getDate();
    const hours = recDate.getHours();
    const minutes = recDate.getMinutes().toString().padStart( 2, '0');
    const dateString = year + "年" + month + "月" + day + "日";
    const timeString = hours + ":" + minutes;
    return (dateString + " " + timeString);
}


/**
 * 現在日付をYYYYMM形式で返す
 * @return YYYYMM形式の日付
 */
export function getCurrentYyyymm()
{
    // let date = convJST(new Date());
    // return getYyyymmFromDate(convJST(new Date()));
    return getYyyymmFromDate(new Date());
}

/**
 * 引数で渡されたDateをYYYYMM形式で返す
 * ＠param date Dateオブジェクト
 * @return YYYYMM形式の日付
 */
export function getYyyymmFromDate(date: Date)
{
    return date.getFullYear() + padZero(date.getMonth() + 1);
}


/**
 * 現在日付をYYYYMMDD形式で返す
 * @return YYYYMMDD形式の日付
 */
export function getCurrentYyyymmdd()
{
    return getYyyymmddFromDate(new Date());
}

/**
 * 引数で渡されたDateをYYYYMMDD形式で返す
 * ＠param date Dateオブジェクト
 * @return YYYYMMDD形式の時刻
 */
export function getYyyymmddFromDate(date: Date)
{
    return date.getFullYear() + padZero(date.getMonth() + 1) + padZero(date.getDate());
}

/**
 * 現在時刻をYYYYMMDDHHMMSS形式で返す
 * @return YYYYMMDDHHMMSS形式の時刻
 */
export function getCurrentYyyymmddhhmmss()
{
    return getYyyymmddhhmmssFromDate(new Date());
}

/**
 * 引数で渡されたDateをYYYYMMDDHHMMSS形式で返す
 * ＠param date Dateオブジェクト
 * @return YYYYMMDDHHMMSS形式の時刻
 */
export function getYyyymmddhhmmssFromDate(date: Date)
{
    return date.getFullYear() + padZero(date.getMonth() + 1) + padZero(date.getDate()) + padZero(date.getHours()) +
        padZero(date.getMinutes()) + padZero(date.getSeconds());
}

/**
 * 引数で指定された年月(YYYYMM)の翌月をYYYYMM形式で返す
 * @param yyyymm 基になるYYYYMM形式の年月
 * @returns YYYYMM形式の翌月
 */
export function getNextYyyymm(yyyymm: string)
{
    const nextYyyymmdd = new Date(
        parseInt(yyyymm.substring(0, 4)), parseInt(yyyymm.substring(4, 6)) , 1
        );
    return nextYyyymmdd.getFullYear()+padZero(nextYyyymmdd.getMonth() + 1); 
}

/**
 * 引数で指定された年月(YYYYMM)の前月をYYYYMM形式で返す
 * @param yyyymm 基になるYYYYMM形式の年月
 * @returns YYYYMM形式の前月
 */
export function getPrevYyyymm(yyyymm: string)
{
    const prevYyyymmdd = new Date(
        parseInt(yyyymm.substring(0, 4)), parseInt(yyyymm.substring(4, 6)) - 2, 1
        );
    return prevYyyymmdd.getFullYear()+padZero(prevYyyymmdd.getMonth() + 1); 
}

/**
 * 対象日時が開始日時、終了日時の範囲内かチェックする
 *
 * @param beginYyyymmddhhmmss 開始日時(YYYYMMDDHHMMSS形式）
 * @param endYyyymmddhhmmss 終了日時(YYYYMMDDHHMMSS形式）
 * @param Yyyymmddhhmmss 対象日時(YYYYMMDDHHMMSS形式）
 * @return true - 範囲内、false - 範囲外
 */
export function isTheDayBetween(beginYyyymmddhhmmss: string, endYyyymmddhhmmss: string, Yyyymmddhhmmss: string)
{
    if ( (beginYyyymmddhhmmss != null && beginYyyymmddhhmmss > Yyyymmddhhmmss)
        || (endYyyymmddhhmmss != null && Yyyymmddhhmmss > endYyyymmddhhmmss) )
    {
        return false;
    }
    else { return true; }
}

/**
 * 現在日時が開始日時、終了日時の範囲内かチェックする
 *
 * @param beginYyyymmddhhmmss 開始日時(YYYYMMDDHHMMSS形式）
 * @param endYyyymmddhhmmss 終了日時(YYYYMMDDHHMMSS形式）
 * @return true - 範囲内、false - 範囲外
 */
export function isToDayBetween(beginYyyymmddhhmmss: string, endYyyymmddhhmmss: string)
{
    return(isTheDayBetween(beginYyyymmddhhmmss, endYyyymmddhhmmss, getCurrentYyyymmddhhmmss()));
}

/**
 * 降順のYYYYMMリストを返す
 * 
 * @param beginDate 開始日時 
 * @param endDate 終了日時
 * @returns 降順のYYYYMMリスト(YYYYMM形式)
 */
export const createYYYYMMList = function (beginDate: Date, endDate: Date)
{
    const dd = new Date(endDate);
    const yyyymmList = [];
	for (let i = 0; beginDate <= dd; i++ )
	{
        yyyymmList.push(dd.getFullYear()+padZero(dd.getMonth() + 1));
        dd.setMonth(dd.getMonth() - 1); 
	}
	return yyyymmList;
}

/**
 * 引数で受け取った日付を引数で受け取った日数だけ加算、減算する
 * @param yyyymmdd 変更する日付(YYYYMMDD形式)
 * @param days 加算、減算する日数。減算の場合はマイナイスを指定する
 * @returns 計算後の日付(YYYYMMDD形式)
 */
export const addDays = function (yyyymmdd: string, days: number)
{
    const ymd = new Date(
        parseInt(yyyymmdd.substring(0, 4)),
        parseInt(yyyymmdd.substring(4, 6)) - 1,
        parseInt(yyyymmdd.substring(6, 8)));
    ymd.setDate(ymd.getDate() + days);
    return(ymd.getFullYear()+(padZero(ymd.getMonth() + 1))+padZero(ymd.getDate()));
}

/**
 * 引数で受け取った日付を引数で受け取った日数だけ加算、減算したDateオブジェクトを返す
 * @param yyyymmddhhmm 変更する日付(YYYYMMDDHHMM形式)
 * @param mins 加算、減算する分数。減算の場合はマイナイスを指定する
 * @returns 計算後の日付(Date形式)
 */
export const addMinsInDate = function (yyyymmddhhmm: string, mins: number)
{
    const newYyyymmddhhmmss = new Date(
        parseInt(yyyymmddhhmm.substring(0, 4)),
        parseInt(yyyymmddhhmm.substring(4, 6)) - 1,
        parseInt(yyyymmddhhmm.substring(6, 8)),
        parseInt(yyyymmddhhmm.substring(8, 10)),
        parseInt(yyyymmddhhmm.substring(10, 12))
        );
        newYyyymmddhhmmss.setMinutes(newYyyymmddhhmmss.getMinutes() + mins);
    return(newYyyymmddhhmmss);
}

//=================================================================
// 文字列操作用スクリプト
//=================================================================

/**
 * 全角数字とハイフンを半角数字に変換する（郵便番号、電話番号用）
 * @param str 全角数字＋ハイフン
 * @return 変換後文字列、変換エラーの場合はnull
 */
export function zen2HanNum(str: string)
{
    if ( str == null || str.length == 0 ) { return; }
    try
    {
        const hankaku = str.replace(/[Ａ-Ｚａ-ｚ０-９]|－/g,function(s){return String.fromCharCode(s.charCodeAt(0)-0xFEE0)});
        // 半角数字と+-のみ残す
        const zenkakuDel = new String( hankaku ).match(/\d|-/g);
        if ( zenkakuDel == null ) { return null; }
        else { return zenkakuDel.join(""); }
    }
    catch(e) { return null; }
}

/**
 * 指定された文字数でランダムな英数文字列を生成する
 * @param len 生成する文字列の文字数
 * @returns 生成されたランダムな英数文字列
 */
export function getRandomAlphaNum(len: number)
{
    const  S="abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    return Array.from(Array(len)).map(()=>S[Math.floor(Math.random()*S.length)]).join('');
}

//=================================================================
// その他
//=================================================================

/**
 * base64のバーコードコードを返す
 * @param url サーバーURL
 * @param cc クーポンコード
 * @return base64のバーコード
 */

/**
 * 2桁の数字の0埋めを行う
 * @retunr 0埋めされた２桁の数字
 */
export function padZero(num: number)
{
    return (num < 10 ? "0" : "") + num;
}

/**
 * パーセントを返す
 * @param num 分子
 * @param denom 分母
 * @param decim 小数点以下桁数
 * @returns {Number}
 */
export function getRatio(num: number, denom: number, decim: number)
{
  if(num > denom) {throw('num must be less or equal than denom')}

  decim = Math.min(16, decim || 0);
  return Math.floor((num / denom) * Math.pow(10, 2 + decim)) / Math.pow(10, decim);
}

/**
 * ダイナミックリンク用パラメーターをキーと値に分割した連想配列を返す
 *
 * @param dl 例) https://memotta.com/01/p/login.html?mn=782&ymd=20220101
 * @return キーと値に分割した連想配列
 */
export function getParamsDeeplink(dl: string)
{
    console.log("getParamsDeeplink() params="+dl);

    let key: string[];
    const params: {[key:string]: string} = {};
    // URLとパラメーターに分割する
    const p1 = dl.split("?");
    // パラメーターがない場合は処理をしない
    if ( p1.length >= 2 )
    {
        for ( let i = 0; i < p1.length; i++ )
        {
            // 複数のパラメータを分割する
            const p2 = p1[i].split("&");
            for ( let j = 0; j < p2.length; j++ )
            {
                // キーと値に分けるkey
                key = p2[j].split("=");
                if ( key != null && key.length >= 2 )
                {
                    params[key[0]] = key[1];
                    console.debug("key:"+key[0]+"="+key[1]);
                }
            }
        }
    }
    return params;
}